export default __webpack_public_path__ + "static/media/arrows-move-filled-lime.584f4aef.svg";